import { labels } from './labels';

/**
 * Libellés affichés pour les outils MCP utilisés par l'assistant
 * (agence_api/src/mcp/tools). Un outil absent de la liste s'affiche sous son
 * nom technique — ajouter ici tout nouvel outil MCP.
 */
export const ASSISTANT_TOOL_LABELS: Record<string, string> = {
  list_tiers:                 `Recherche des ${labels.tiersPluriel.toLowerCase()}`,
  list_categories_tiers:      `Catégories de ${labels.tiersPluriel.toLowerCase()}`,
  list_articles:              'Recherche des articles',
  list_familles:              "Familles d'articles",
  get_stock:                  'Consultation du stock',
  get_balance_compte:         'Soldes des comptes',
  list_comptes:               'Mouvements de comptes',
  get_compte_resultat:        'Compte de résultat',
  get_situation_patrimoniale: 'Situation patrimoniale',
  get_stat_ventes:            'Statistiques de ventes',
  list_departements:          'Départements',
  list_depots:                'Dépôts',
  list_caisses:               'Caisses',
  list_reglements:            `Recherche des ${labels.reglementPluriel.toLowerCase()}`,
  list_modes_reglement:       `Modes de ${labels.reglement.toLowerCase()}`,
  list_natures_reglement:     `Natures de ${labels.reglement.toLowerCase()}`,
  list_categories_nature_reglement: `Catégories de nature de ${labels.reglement.toLowerCase()}`,
  list_documents_vente:       `Recherche des ${labels.documentVentePluriel.toLowerCase()}`,
  list_lignes_document_vente: `Lignes de ${labels.documentVente.toLowerCase()}`,
  create_proforma_client:     'Créer un proforma',
  add_ligne_proforma:         'Ajouter une ligne au proforma',
  update_ligne_proforma:      'Modifier une ligne du proforma',
  delete_ligne_proforma:      'Supprimer une ligne du proforma',
  get_proforma_pdf:           'PDF du proforma',
};

export const assistantToolLabel = (name: string): string => ASSISTANT_TOOL_LABELS[name] ?? name;

/** Clé localStorage de la conversation — une par utilisateur, purgée au logout (authActions). */
export const assistantStorageKey = (userId: number): string => `assistant_chat_${userId}`;
